/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { StatLibMock, StatLibMockInterface } from "../StatLibMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256",
      },
    ],
    name: "TooLowX",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "UnknownHeroClass",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dexterity",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "attackRating",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dexterity",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "blockRating",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "attackersAttackRating",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "defendersDefenceRating",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "attackersLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "defendersLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "arFactor",
        type: "uint256",
      },
    ],
    name: "chanceToHit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dexterity",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "defense",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
    ],
    name: "levelExperience",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "vitality",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
    ],
    name: "life",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "energy",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "level",
        type: "uint32",
      },
    ],
    name: "mana",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "strength",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "maxDamage",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "strength",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
    ],
    name: "minDamage",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class StatLibMock__factory {
  static readonly abi = _abi;
  static createInterface(): StatLibMockInterface {
    return new Interface(_abi) as StatLibMockInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): StatLibMock {
    return new Contract(address, _abi, runner) as unknown as StatLibMock;
  }
}
